module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS9JREFUeNpi/P//PwOtAeOwsYQBZAkJOBGITwNxJCn6SLEg9j8qCKO2JZH/sYMgalkSiGbwATS+F6WWeKMZWAgVr0QTdyHXEnQLcqHi8lC6BE3elVRL3NAMyICKV0H5jVB+Hpo6e2ItcULTmAQVr0ATr4OKZ6CJWxOyxA5NQwyOOICBeqh8Epq4BS5LXNEURhKwAN2ieDRxO2yWwMBvIA4m0gIYaICqjwLiP+iJAdkSUFjqArEMlJ/7nzRQDNUnBzUHZJ4qvtSl+Z88oIXNPCYc5SY3FrEnQBwLxC5AHA3ED7Go4SSlFNbH4soQAsXNf6g+on2CDbxG478nViMplvAQEaQkWcJKRHhzEqmPgQWHJV+A+CYs2oCYGUtwgfi3gfgvqBpH0jeMGxJ0sQQgwABUVbqIsCXcCgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/sidebar-_tem1.png
// module id = 975
// module chunks = 1